import { InjectionToken } from '@angular/core';
import { Auth } from 'firebase/auth';
import { Firestore } from 'firebase/firestore';
import { Functions } from 'firebase/functions';
import { FirebaseStorage } from 'firebase/storage';
import { AI } from 'firebase/ai';

export const FIREBASE_AUTH = new InjectionToken<Auth>('firebase-auth');
export const FIREBASE_FIRESTORE = new InjectionToken<Firestore>(
  'firebase-firestore',
);
export const FIREBASE_FUNCTIONS = new InjectionToken<Functions>(
  'firebase-functions',
);
export const FIREBASE_STORAGE = new InjectionToken<FirebaseStorage>(
  'firebase-storage',
);
export const FIREBASE_AI = new InjectionToken<AI>('firebase-ai');
